module.exports = __webpack_public_path__ + "img/hand-fingers-crossed.0ace93dd.svg";